import { Component, OnInit, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { kpi, sla, filecontent, kpitarget, actionPlan, slaIssueList, quater, year } from './../../../models/slakpi';
import { division, user, department, targetMaster } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from './../../../services/user.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,
  getHtmlElementOffset,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { formatDate } from '@angular/common';
import { ToasterService } from '../../../toaster.service';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'action-plan',
  templateUrl: './action-plan.component.html',
  styleUrls: ['./action-plan.component.css']

})
export class ActionPlanComponent implements OnInit {

  showMyContainer: boolean = false;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  chartOption05: EChartsOption;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('attachmentTemplate', { static: false }) attachmentTemplate: TemplateRef<any>;

  headerTitle: string;
  @ViewChild('editSettingsTemplate', { static: false }) editSettingsTemplate: TemplateRef<any>;
  public defaultyear: number = 0;
  public selected_kpiUno: number = 0;
  public kpiTargetForm: FormGroup;
  public yearsArray: FormArray;
  public selected_schedule: number = 1;
  public submitClicked: boolean = false;

  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any=[];
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  public division_data: any;
  public department_data: any;
  public slaTypeUno_data: any;
  public target_data: any;
  public trend_data: any;
  public condition2_data: any;
  public slaStatusRule_data: any;
  public dataEntry_data: any;
  public user_data: any;
  public dataEntry_data_filter: any;
  public user_data_filter: any;
  public frequency_data: any;
  public selected_kpiCode: string = '';
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  public orderData: object;
  public kpiData: object[];
  public kpiForm: FormGroup;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  isShow = false;
  public uploadedFiles: Array<File> = [];


  public permission: number = 1;
  public divisionUno_filter: number = 0;
  public checkbox_filter: boolean = false;
  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  objActionPlan: any = new actionPlan();
  objSLA: any = new sla();
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  angularGrid: AngularGridInstance;
  //For Filter

  public sli_data: any;

  SLAno: string;
  AttachmentList: any;
  fileItemCount: any;
  fileContent: any;
  searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
  slaIssuelist_Kpi: any=[];
  kpiUno: any;
  @ViewChild('mapKPIDialog', { static: false }) mapKPItemplate: TemplateRef<any>;
  permision_resolve: boolean = false;
  mindate: any;
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  public yearUno?: number;
  public quarterUno?: number;

  pendingActions: number = 0;
  inProgressActions: number = 0;
  completedActions: number = 0;
  totalActions: number = 0;
  public yearData: any=[];
  public quaterData: any;
  actionYearUno: any;
  actionQuarterUno: any;
  constructor(private formBuilder: FormBuilder, public restApi: SLAKPIApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    //To Validate User Permission
    this.mindate = this.utilityService.getCurrentdate();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.defaultyear = this.user.currentYear;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;

    this.actionYearUno = this.currentYear;
    this.actionQuarterUno = this.currentQuarter;

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly' ) ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    } else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;

    }
    
    

  }



  ngOnInit() {
    //if (localStorage.getItem('strFilter')) {
    //  localStorage.removeItem('strFilter')
    //}
    this.loadYear();
    this.loadQuater();
    this.actionYearUno = Number(this.currentYear);
    this.actionQuarterUno = Number(this.currentQuarter);
    if (localStorage.getItem('strFilter')) {
      let strFilter = JSON.parse(localStorage.getItem('strFilter'));
      if (strFilter.yearUno != undefined) {
        this.actionYearUno = Number(strFilter.yearUno);
      }
      if (strFilter.quarterUno != undefined) {
        this.actionQuarterUno = Number(strFilter.quarterUno);
      }

    }
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: false,
      //frozenColumn: 3,


    };
    
    this.getDivisions();
    this.getSLAType();
    this.getUsers();
    this.loadSlaIssueList(5);
    

  }

  onchangeYear(e) {
    
    this.actionYearUno = (e && e.length > 0) ? e[0].value : 0;
    this.loadActionPlan();
    this.loadSlaIssueList(5);
  }


  onchangeQuarter(e) {
    
    this.actionQuarterUno = (e && e.length > 0) ? e[0].value : 0;
    this.loadActionPlan();
    this.loadSlaIssueList(5);
  }

  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getYearMaster(inpValue)
      .subscribe((data:any) => {
        
        var length = data.length;
        var yearArray = [];
        yearArray.push({ displayText: "All",  value: 0 });
        data.forEach(function (item, index) {
          //if (length == index+1)

          yearArray.push({ displayText: item.displayText, value: item.value })
          //return
        });
        this.yearData = yearArray;
       /* this.yearData = this.yearData.push({ condition: 0, displayText: "All", itemUno: 0, languageUno: 0, tenantUno: 0, userUno: 0, value: 0 })*/
        setTimeout(() => {
          this.actionYearUno = Number(this.actionYearUno);
          this.loadActionPlan();
        }, 10);

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 3;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getQuaterMaster(inpValue)
      .subscribe(data => {
        
        this.quaterData = data;
        setTimeout(() => {
          
          this.actionQuarterUno = Number(this.actionQuarterUno);
          //this.loadSlaIssueList(2); //by filter
          //this.loadDashboard(2);
        }, 10);


      },
        (error) => {
          //Called when error
          //this.loadSlaIssueList(2); //by filter
          //this.loadDashboard(2);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("SLA Issue List");
    if (this.user.role == 'SLA Admin') {
      this.permision_resolve = true;

    }
    else if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;

        if (this.user.role == 'SLA Admin' || this.user.role == 'SLA Coordinator') {
          this.permision_resolve = true;

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.slaReference && a.slaReference.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.slaNameEn && a.slaNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaTypeNameEn && a.slaTypeNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.reportingAccName && a.reportingAccName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.businessAccNameEn && a.businessAccNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.fSignOffDate && a.fSignOffDate.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      //{
      //  id: 'actionPlanID', name: 'ID', field: 'actionPlanID', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'actionPlanID', 'actionPlanID'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'actionPlanCode', name: 'Code', field: 'actionPlanCode', sortable: true, type: FieldType.string, filterable: true,
        width: 100,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.actionPlanCode;
          //let dataset = "' " + per +"' "
          return '<div title="' + per + '">' + per + '</div>'

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'actionPlanCode', 'actionPlanCode'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'actionPlanBrief', name: 'Action Plan Description', field: 'actionPlanBrief', sortable: true,
        width: 200,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.actionPlanBrief;
          //let dataset = "' " + per +"' "
          return '<div title="' + per + '">' + per + '</div>'

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'actionPlanBrief', 'actionPlanBrief'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, type: FieldType.string, filterable: true,
        width: 100,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.kpiNameEn;
          //let dataset = "' " + per +"' "
          return '<div title="' + per + '">' + per + '</div>'

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'startDate', name: 'Start', field: 'startDate', sortable: true,
        width: 75,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'Start', 'Start'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'endDate', name: 'End', field: 'endDate', selectable: false,
        width: 75,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'endDate', 'endDate'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'completion', name: 'Overall Progress', field: 'completion', sortable: true,
        width: 100,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.completion;

          return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'completion', 'completion'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'kpiUno', name: 'KPI', field: 'kpiUno', sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'kpiUno', 'kpiUno'),
      //    model: Filters.multipleSelect,
      //  }
      //},

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue',
        maxWidth: 75,
        //width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                // this.objActionPlan = this.data.filter((items: any) => items.actionPlanDetailID == data.id)[0];
                //if (data.completion != 100 )
                //  return true;
                //else false;
                
                if (this.user.role == 'SLA Coordinator') {
                  if (data.completion != 100)
                    return true;
                  else false;
                }
                else {
                  return true;
                }
              },
              action: (e, args) => {
                this.pageAction = 'edit';

                //debugger;
                if (this.actionQuarterUno==5) {
                  this.toaster.show('error', 'Error', 'Please select specific quarter');
                  return false;
                }

                if (this.permission == 1) {
                  let rdata: any = args.dataContext;
                  //this.selTab = true;
                  //this.SLAno = rdata.id;
                  //this.uploadedFiles = [];
                  //this.getFiles(rdata.id);
                  this.objActionPlan = this.data.filter((items: any) => items.actionPlanID == rdata.id)[0];
                  this.objActionPlan.kpiUno = (this.objActionPlan.kpiUno) ? this.utilityService.CommaSeperatorToArrayParseInt(this.objActionPlan.kpiUno.toString()) : [];
                  //this.objActionPlan.startDate = formatDate(this.objActionPlan.startDate, 'yyyy-MM-dd', 'en-US');
                  //this.objActionPlan.endDate = formatDate(this.objActionPlan.endDate, 'yyyy-MM-dd', 'en-US');
                  this.objActionPlan.startDate = formatDate(this.objActionPlan.startDateFormat, 'yyyy-MM-dd', 'en-US');
                  this.objActionPlan.endDate = formatDate(this.objActionPlan.endDateFormat, 'yyyy-MM-dd', 'en-US');
                  this.objActionPlan.condition =1
                  this.modalRef = this.modalService.show(
                    this.addtemplate,
                    Object.assign({}, {
                      class: 'gray modal-medium',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                }
              },
              // only show command to 'Delete Row' when the task is not completed

            },

            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                this.objActionPlan.condition = 2
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteActionPlan(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                    this.loadActionPlan();
                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },

            {
              command: 'view', titleKey: 'view', positionOrder: 62, title: 'View',
              iconCssClass: 'fa fa-eye', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                var rdata = args.dataContext;
                this.objActionPlan = this.data.filter((items: any) => items.actionPlanID == rdata.id)[0];

                this.router.navigate(['/dashboard-actionplandetail'], {
                /*queryParams: { actionPlanId: rdata.id, actionCode: this.objActionPlan.actionPlanCode, actionBrief: this.objActionPlan.actionPlanBrief }*/
                  queryParams: { actionPlanId: rdata.id}
                })
                //, { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });
              }
            },

            {
              command: 'mapKPI', titleKey: 'mapkpi', positionOrder: 62, title: 'Map KPI',
              iconCssClass: 'fa fa-link', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                var rdata = args.dataContext;
                this.pageAction = "Map"
                this.objActionPlan = this.data.filter((items: any) => items.actionPlanID == rdata.id)[0];
                this.objActionPlan.kpiUno = (this.objActionPlan.kpiUno) ? this.utilityService.CommaSeperatorToArrayParseInt(this.objActionPlan.kpiUno.toString()) : [];
                this.objActionPlan.startDate = formatDate(this.objActionPlan.startDateFormat, 'yyyy-MM-dd', 'en-US');
                this.objActionPlan.endDate = formatDate(this.objActionPlan.endDateFormat, 'yyyy-MM-dd', 'en-US');
                this.objActionPlan.condition = 3
                this.modalRef = this.modalService.show(
                  this.mapKPItemplate,
                  Object.assign({}, {
                    class: 'gray modal-medium',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
                //, { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });
              }
            }
          ],
        }
      }




    ]


  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  onDbClicked(e, es) {
    
    let objitem = this.angularGrid.gridService.getDataItemByRowIndex(es.row)

    if (objitem != null && objitem != undefined) {
      this.objActionPlan = this.data.filter((items: any) => items.actionPlanID == objitem.id)[0];

      this.router.navigate(['/dashboard-actionplandetail'], {
        queryParams: { actionPlanId: objitem.id, actionCode: this.objActionPlan.actionPlanCode, actionBrief: this.objActionPlan.actionPlanBrief }
      })
    }
  }

  handleOnMouseEnter(e) {
    
    if (this.angularGrid.slickGrid && e) {
      const cell = this.angularGrid.slickGrid.getCellFromEvent(e);
      if (cell) {
        const item = this.angularGrid.dataView.getItem(cell.row);
        // const columnDef = this.sgb.slickGrid.getColumns()[cell.cell];
        const cellPosition = getHtmlElementOffset(this.angularGrid.slickGrid.getCellNode(cell.row, cell.cell));
        const tooltipElm = document.createElement('div');
        tooltipElm.className = 'some-tooltip'; // you could also add cell/row into the class name
        tooltipElm.innerHTML = `<div><label>Id:</label> ${item.id}</div><div><label>Title:</label> ${item.title}</div>`;
        document.body.appendChild(tooltipElm);
        tooltipElm.style.top = `${cellPosition.top - tooltipElm.clientHeight - 3}px`;
        tooltipElm.style.left = `${cellPosition.left}px`;
      }
    }
  }

  handleOnMouseLeave() {
    // don't forget to destroy tooltip when leaving the cell
    // you could also use the event if you provided cell/row into the class name
    const prevTooltip = document.body.querySelector('.some-tooltip');
    prevTooltip.remove()
  }



  onSubmitKPI() {
    this.AddEditSLA(this.objActionPlan);
  }
  // Get ActionPlan list
  loadActionPlan() {
    this.spinner.show();
    let inpValue = new actionPlan();
    inpValue.languageUno = 1033;
    //inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.yearUno = this.actionYearUno;
    inpValue.quarterUno = this.actionQuarterUno;
    this.pendingActions = 0;
    this.inProgressActions = 0;
    this.completedActions = 0;
    this.totalActions = 0;
    this.restApi.getActionPlan(inpValue)
      .subscribe(data => {
        
        this.data = data;
        //if (!this.isAdmin) {
        //  this.data = this.data.filter(a =>
        //    (a.divisionUno.toString() == this.user.divisionUno.toString()));

        //}
       

        const mockDataset = [];

        let totalPercentage = 0;
        let OverallProgress = 0;
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].completion == "") {
            this.data[i].completion = 0
            this.pendingActions += 1
          }
          if (this.data[i].completion != "" && this.data[i].completion != "100" && this.data[i].completion != "0") {
            
            this.inProgressActions += 1
          }
          if (this.data[i].completion == "100") {
            this.completedActions += 1
          }
          mockDataset[i] = {
            id: this.data[i].actionPlanID,
            actionPlanCode: this.data[i].actionPlanCode,
            actionPlanBrief: this.data[i].actionPlanBrief,
            completion: this.data[i].completion,
            startDate: this.data[i].startDate,
            endDate: this.data[i].endDate,
            kpiUno: this.data[i].kpiUno,
            divisionUno: this.data[i].divisionUno,
            kpiNameEn: this.data[i].kpiNameEn
          };

          totalPercentage = totalPercentage + parseFloat(this.data[i].completion);

          
        }

        OverallProgress = Math.round((totalPercentage / this.data.length));
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        this.totalActions = this.dataset.length;
        //this.dataset = this.data;
        //this.dataSearch = this.data;
        let completedItems = this.dataset.filter((a: any) =>
          a.completion == '100')
        let inProgressItems = this.dataset.filter((a: any) =>
          a.completion != "" && a.completion != "0" && a.completion != "100")
        let pendingItems = this.dataset.filter((a: any) =>
          a.completion == "" || a.completion == "0")
        
        var groupBy = function (xs: any, key: any) {
          return xs.reduce(function (rv: any, x: any) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
          }, {});
        };

        let groupTotalActions = groupBy(this.dataset, 'actionPlanCode');
      
        let groupCompletedActions = groupBy(completedItems, 'actionPlanCode');

        let groupInprogressActions = groupBy(inProgressItems, 'actionPlanCode');

        let groupPendingActions = groupBy(pendingItems, 'actionPlanCode');

        this.pendingActions = Object.keys(groupPendingActions).length;
        this.inProgressActions = Object.keys(groupInprogressActions).length;
        this.totalActions = Object.keys(groupTotalActions).length;
        this.completedActions = Object.keys(groupCompletedActions).length;

       

        if (this.data.length > 0) {
          this.setColnDefn();

          this.chartOption05 = {

            //tooltip: {
            //  trigger: 'item'
            //},
            color: ['#68b097', '#d0e6de'],
            legend: {
              top: '5%',
              show: false,
              left: 'center'
            },
            series: [
              {
                name: 'Access From',
                type: 'pie',
                radius: ['55%', '70%'],
                avoidLabelOverlap: false,
                // label: {
                //   show: false,
                //   position: 'center'
                // },
                label: {

                  color: '#000',
                  fontSize: '30',
                  silent: true,
                  position: 'center',
                  formatter: () => {
                    // return "96%" // Use sum variable here
                    return (OverallProgress.toString() + '%');
                  },
                },
                // emphasis: {
                //   label: {
                //     show: false,
                //     fontSize: '40',
                //     fontWeight: 'bold'
                //   }
                // },
                labelLine: {
                  show: false
                },
                data: [
                  { value: OverallProgress },
                  { value: (100 - (OverallProgress)) },
                ]
                //data: data,
              }
            ]
          };
        } else {
         
          this.dataset = [];
        }
        //else {
        //  this.loading = true;
        //}
        this.kpiData = mockDataset;
        this.loading = false;
        this.spinner.hide()

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        let divisiondata:any = data;
        this.division_data = data;
        //if (!this.isAdmin && divisiondata !=null) {
        //  this.division_data = divisiondata.filter(a =>
        //    (a.divisionUno.toString() == this.user.divisionUno.toString()));
        //  //|| (a.reportingDivisionUno.toString() == this.user.divisionUno.toString())
        //}
        //else {
        //  this.division_data = data;
        //}
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getSLAType() {

    let inpValue = new sla();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getSLATypes(inpValue)
      .subscribe(data => {
        this.slaTypeUno_data = data;

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getUsers() {

    let inpValue = new user();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {
        
        this.user_data = data;
        this.dataEntry_data = data;
        this.user_data_filter = data;
        this.dataEntry_data_filter = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  DeleteActionPlan(data1: any) {

    let objDeaprtment = new actionPlan();
    // objDeaprtment.actionType = this.pageAction;
    objDeaprtment.actionPlanID = data1.id;
    objDeaprtment.userUno = this.login_UserID;
    objDeaprtment.tenantUno = 1;

    this.restApi.deleteActionPlan(objDeaprtment)
      .subscribe(data => {

        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'Action Plan deleted.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'SLA deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadActionPlan();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }



  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }
  uploadFiles() {
    this.spinner.show();
    
    if (this.uploadedFiles.length > 5) {
      this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
      return false;
    }
    for (var i = 0; i < this.uploadedFiles.length; i++) {
      let allowFile = false;
      let fileName = this.uploadedFiles[i].name.toLowerCase();
      let fileSize = this.uploadedFiles[i].size;
      //Check file size
      let allowFileSize = false;
      allowFileSize = this.userService.checkFileSize(fileSize);
      if (!allowFileSize) {
        this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
        return;
      }
      //To check filee size exe  
      allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

      if (allowFile) {
        this.restApi.SLAFileUpload(this.uploadedFiles[i], this.uploadedFiles[i].name, this.SLAno).subscribe(data => {

          this.spinner.hide();
        },
          (error) => {
            //Called when error
            // Swal.fire('Error', 'Something went wrong', 'error')
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
      }
    }
  }

  DuplicateNameCheck(slaUno: number, slaNameEn: string, slaNameAr: string) {
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {

        if ((slaUno != grdData.slaUno) && (grdData.slaNameEn.toLocaleLowerCase() == slaNameEn.toLocaleLowerCase() || grdData.slaNameAr.toLocaleLowerCase() == slaNameAr.toLocaleLowerCase())) {
          rtnValue = true;
        }
      });

      return rtnValue;
    }
  }


  onClickAttachment(SLAno: string): void {
    
    this.getFiles(SLAno);
  }

  AddEditSLA(data1: any) {
    if (this.objActionPlan.startDate > this.objActionPlan.endDate) {
      /* Notiflix.Notify.failure('From date is not greater than to date', { timeout: 3000, position: 'right-bottom' });*/
      //Notiflix.Notify.failure('From Date cannot be greater than To Date', { timeout: 3000, position: 'right-bottom' });
      this.toaster.show('error', 'Error', 'Start Date cannot be greater than End Date');
      return false;
    }
    if (this.objActionPlan.condition == 3) {
      let SelectedActionData = this.dataset.filter(a => a.id.toString() == this.objActionPlan.actionPlanID.toString());

      this.objActionPlan.divisionUno = SelectedActionData[0].divisionUno;
    }


    //let selectedDivisionData: any;
    //let divisionUno: any;
    //selectedDivisionData = this.slaIssuelist_Kpi.filter(a => a.kpiUno.toString() == this.objActionPlan.kpiUno.toString());
    //divisionUno = selectedDivisionData[0].divisionUno;
    //if (divisionUno.toString() != this.objActionPlan.divisionUno.toString()) {
    //  this.toaster.show('error', 'Error', 'Please select KPI from same Division');
    //  return false;
    //}


    this.objActionPlan.actionType = this.pageAction;
    this.objActionPlan.actionPlanID = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(this.objActionPlan.actionPlanID);
    this.objActionPlan.userUno = this.login_UserID;
    this.objActionPlan.tenantUno = this.tenantUno;
    this.objActionPlan.kpiUno = (this.objActionPlan.kpiUno) ? this.objActionPlan.kpiUno.toString() : '';
    this.objActionPlan.divisionUno = (this.objActionPlan.divisionUno) ? this.objActionPlan.divisionUno.toString() : '';
    let kpi = this.objActionPlan.kpiUno;
    let DivisionBackup = this.objActionPlan.divisionUno;

    this.objActionPlan.yearUno = this.actionYearUno ? this.actionYearUno : 0;
    if (this.actionQuarterUno != null && this.actionQuarterUno < 5) {
      this.objActionPlan.quarterUno = this.actionQuarterUno ? this.actionQuarterUno : 0;
    }

    this.spinner.show();
    this.restApi.addEditActionPlan(this.objActionPlan)
      .subscribe(data => {
        
        if (data == null && data != undefined && data != '' && (data.toString().indexOf('MSID_') <= 0)) {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.objActionPlan.condition = 0;
          if (data == '999') {
            Swal.fire({
              title: 'Confirmation',
              text: 'KPI already mapped to another Plan.Do you want to continue?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'Cancel'
            }).then((result) => {
              if (result.value) {
                this.objActionPlan.condition = 5;
                this.objActionPlan.kpiUno = kpi;
                this.objActionPlan.divisionUno = DivisionBackup;
                this.AddEditSLA('data')
              } else if (result.dismiss === Swal.DismissReason.cancel) {

                //this.loadActionPlan();
              }
            })
            //this.toaster.show('error', 'Error', 'KPI already mapped to another Plan, please try other kpi');
          } else {
            if (this.pageAction = "Map") {
              this.toaster.show('success', 'Success', 'KPI Mapped.');
            }
            else {
              this.toaster.show('success', 'Success', 'Action Plan saved.');
            }

            //Swal.fire({
            //  type: 'success',
            //  title: 'SLA saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            
            this.modalRef.hide();
            //this.SLAno = (this.pageAction == "add") ? data.toString() : this.SLAno;
            //this.uploadFiles();
            this.loadActionPlan();
          }
        }
        setTimeout(() => { this.spinner.hide(); this.loadActionPlan(); }, 1100);
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    //}
  }

  getFiles(slaUno: string) {
    this.AttachmentList = null;
    let inpValue = new filecontent();
    inpValue.masterUNo = slaUno;
    inpValue.itemUNo = '0';
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.SLAno = slaUno;
    this.restApi.SLA_FileSelect(inpValue)
      .subscribe(data => {
        this.AttachmentList = data;
        this.fileItemCount = (this.AttachmentList != undefined && this.AttachmentList != null) ? this.AttachmentList.length : 0;
        this.spinner.hide();

      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }

  DeleteAttachment(itemUno: string) {

    //});
    
    let inpValue = new filecontent();
    inpValue.masterUNo = this.SLAno;
    inpValue.itemUNo = itemUno;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.SLA_FileDelete(inpValue)
      .subscribe(data => {
        this.getFiles(this.SLAno);
        //setTimeout(() => { this.spinner.hide(); this.loadSLA(); }, 1100);
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }
  AttachmentDownload(id: any, name: string) {
    let inpValue = new filecontent();
    inpValue.masterUNo = this.SLAno;
    inpValue.itemUNo = id;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.SLA_Filedownload(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
      },
      error => {
        //Swal.fire('Error', 'Something went wrong', 'error')
        this.toaster.show('error', 'Error', 'Something went wrong.');
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }



  openModalWithClass(addtemplate: TemplateRef<any>) {
    if (this.actionQuarterUno == 5) {
      this.toaster.show('error', 'Error', 'Please select specific quarter');
      return false;
    }

    this.pageAction == "add";
    this.uploadedFiles = [];
    this.objActionPlan = new actionPlan();
    this.selTab = true;
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }


  getBooleanValue(checkboxSelector) {
    return document.querySelector(checkboxSelector).checked;
  }
  onNext(val) {
    if (val) {
      this.selTab = false;
    }
    else {
      //Swal.fire('Error', 'Please enter the General Information.', 'error')
      this.toaster.show('error', 'Please enter the Required Information.');
    }
  }
  onSubmit(val) {
    
    if (!val) {
      //Swal.fire('Error', 'Please enter the General Information.', 'error');
      this.toaster.show('error', 'Please enter the Required Information.');
      this.selTab = true;
    }
    else {
      this.AddEditSLA(this.objActionPlan)
    }
  }

  createFormGroup(data1: any) {

    this.kpiTargetForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
  }
  createyearItem(objkpitarget: kpitarget): FormGroup {
    
    return this.formBuilder.group({
      kpiUno: objkpitarget.kpiUno,
      kpiYear: objkpitarget.kpiYear,
      kpiYear_Text: objkpitarget.kpiYear_Text,
      frequency: objkpitarget.frequency,
      kpitarget1: objkpitarget.kpitarget1,
      kpitarget2: objkpitarget.kpitarget2,
      kpitarget3: objkpitarget.kpitarget3,
      kpitarget4: objkpitarget.kpitarget4,
      kpitarget5: objkpitarget.kpitarget5,
      kpitarget6: objkpitarget.kpitarget6,
      kpitarget7: objkpitarget.kpitarget7,
      kpitarget8: objkpitarget.kpitarget8,
      kpitarget9: objkpitarget.kpitarget9,
      kpitarget10: objkpitarget.kpitarget10,
      kpitarget11: objkpitarget.kpitarget11,
      kpitarget12: objkpitarget.kpitarget12,
      kpitarget13: objkpitarget.kpitarget13
    });
  }
  addItem(kpiuno, Frequency): void {
    this.yearsArray = this.kpiTargetForm.get('yearsArray') as FormArray;
    this.spinner.show();
    let inpValue = new kpitarget();
    inpValue.languageUno = 1033;
    inpValue.kpiUno = kpiuno;
    inpValue.kpiYear = this.defaultyear;
    inpValue.frequency = Frequency;
    inpValue.itemUno = 2;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getKpiTargets(inpValue)
      .subscribe(kpidata => {
        let objkpidata: any = kpidata;
        if (objkpidata != null && objkpidata.length > 0)
          for (var i = 0; i < 7; i++) {
            
            this.yearsArray.push(this.createyearItem(kpidata[i]));
          }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });


  }


  AddEditKPITarget(data1: any) {
    if (this.kpiTargetForm == null || this.kpiTargetForm.invalid) {
      // Swal.fire('Error', 'Something went wrong', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong');
      return false;
    }

    
    let objKPITarget = new kpitarget();

    objKPITarget.listkpiTarget = data1.yearsArray;
    objKPITarget.userUno = this.login_UserID;
    objKPITarget.kpiYear = this.defaultyear;
    objKPITarget.kpiUno = this.selected_kpiUno;
    objKPITarget.condition = 1;//(this.pageAction == "add") ? 0 : 1;
    objKPITarget.tenantUno = this.tenantUno;
    objKPITarget.foreCastType = 2;
    
    this.restApi.addKpiTarget(objKPITarget)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'SLA Target Saved.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Target Saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadActionPlan();
        }

        this.modalRef.hide();
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

    return true;

  }

  saveTarget() {
    this.submitClicked = true;
    if (this.kpiTargetForm.valid) {
      this.AddEditKPITarget(this.kpiTargetForm.value);
    }
  }

  onchangeKpi(e) {
    //
    //alert(e.itemData.slaUno);
    //this.slaUno = (e && e.length > 0) ? e[0].value : 0;
    this.loadSlaIssueList(5);

  }

  ngOnDestroy(): void {
    //if (localStorage.getItem('strFilter')) {
    //  localStorage.removeItem('strFilter')
    //}
  }
  // Get SlaIssueList list
  loadSlaIssueList(condition) {

    
   
    //this.spinner.show();
    let inpValue = new slaIssueList();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    //inpValue.slaUno = this.slaUno ? this.slaUno : 0;
    //if (localStorage.getItem('strFilter')) {
    //  let strFilter = JSON.parse(localStorage.getItem('strFilter'));
    //  if (strFilter.quarterUno != undefined) {
    //    inpValue.kpiquarter = Number(strFilter.quarterUno);
    //  }
    //  if (strFilter.yearUno != undefined) {
    //    inpValue.kpiyear = Number(strFilter.yearUno);
    //  }
    //}
    //else {
    //  inpValue.kpiyear = this.yearUno ? this.yearUno : 0;
    //  inpValue.kpiquarter = this.quarterUno ? this.quarterUno : 0;
    //}
    
    inpValue.kpiyear = this.actionYearUno ? this.actionYearUno : 0;
    inpValue.kpiquarter = this.actionQuarterUno ? this.actionQuarterUno : 0;

    this.restApi.getSlaIssueList(inpValue)
      .subscribe(data => {
        
        if (data != null && data != undefined) {
          let kpiList: any = [];
          kpiList = data;
          const mockDataset = [];
          for (let i = 0; i < kpiList.length; i++) {
            mockDataset[i] = {
              kpiUno: kpiList[i].kpiTrnUno,
              kpiName: kpiList[i].kpiName,
              kpiCode: kpiList[i].kpiCode,
              displayName: kpiList[i].kpiCode + ' : ' + kpiList[i].kpiName,
              divisionUno: kpiList[i].businessDivisionUno,
              businessDivisionUno: kpiList[i].businessDivisionUno,
              reportingDivisionUno: kpiList[i].reportingDivisionUno
            }
          }

          //this.slaIssuelist_Kpi = mockDataset;
          if (!this.isAdmin) {
            this.slaIssuelist_Kpi = mockDataset.filter(a =>
              (a.businessDivisionUno.toString() == this.user.divisionUno.toString()));
            //|| (a.reportingDivisionUno.toString() == this.user.divisionUno.toString())
          }
          else {
            this.slaIssuelist_Kpi = mockDataset;
          }
        } 
        
      },
        (error) => {
          //Called when error
          //this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
}
